var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33333 12H12.6667C13.0349 12 13.3333 12.2985 13.3333 12.6667C13.3333 13.0349 13.0349 13.3333 12.6667 13.3333H0.666667C0.298477 13.3333 0 13.0349 0 12.6667V0.666667C0 0.298477 0.298477 0 0.666667 0C1.03486 0 1.33333 0.298477 1.33333 0.666667V12ZM4.66667 8.33333C4.66667 8.88562 4.21895 9.33333 3.66667 9.33333C3.11438 9.33333 2.66667 8.88562 2.66667 8.33333C2.66667 7.78105 3.11438 7.33333 3.66667 7.33333L5.66667 5.33333C5.66667 4.78105 6.11438 4.33333 6.66667 4.33333C7.21895 4.33333 7.66667 4.78105 7.66667 5.33333L8.82 6.50667H8.92667L11.3333 4.1C11.3301 4.06675 11.3301 4.03325 11.3333 4C11.3333 3.44772 11.781 3 12.3333 3C12.8856 3 13.3333 3.44772 13.3333 4C13.3333 4.55228 12.8856 5 12.3333 5L9.90667 7.44667V7.5C9.90667 8.05229 9.45895 8.5 8.90667 8.5C8.35438 8.5 7.90667 8.05229 7.90667 7.5V7.44667L6.83333 6.37333H6.68H6.52667L4.66667 8.23333C4.66992 8.26659 4.66992 8.30008 4.66667 8.33333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphic);
export default __webpack_public_path__ + "static/media/graphic.3901cf7c545d40fa0861bfdf873f01e8.svg";
export { ForwardRef as ReactComponent };